import * as React from "react";

import { cx } from "class-variance-authority";

import { PendoProps } from "../../utils/pendo";

import * as theme from "./Section.css";
import { SectionStyleVariant } from "./types";

// Components here are primarily used to ensure consistent layout and styling for Section components
// Keep composition in mind - create new layouts by e.g. just using Section

const sectionStyleVariantMap: Record<SectionStyleVariant, string> = {
    primary: theme.primarySection, // with shadow - used as a "main" section
    secondary: theme.secondarySection, // without shadow - usually a part of another section or collapsible
};

interface SectionProps extends PendoProps {
    children: React.ReactNode;
    styleVariant?: SectionStyleVariant;
    id?: string;
    className?: string;
}
export function Section({
    children,
    "data-pendo": dataPendo,
    id,
    className,
    styleVariant = "primary",
}: SectionProps) {
    return (
        <div
            id={id}
            data-pendo={dataPendo}
            className={cx(
                theme.section,
                sectionStyleVariantMap[styleVariant],
                className
            )}
        >
            {children}
        </div>
    );
}
